'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validatorjs = require('validatorjs');

var _validatorjs2 = _interopRequireDefault(_validatorjs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (values, rules, errorMessages, attributeNames) {
  var runner = new _validatorjs2.default(values, rules, errorMessages);
  runner.setAttributeNames(attributeNames);
  if (runner.fails()) return {
    formErrors: runner.errors.errors
  };
  return {};
};